<app-auth-base-layout [title]="'Iniciar Sesión'">
    <ng-container auth-content>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="mb-3">
                <label cLabel for="email">Correo electrónico</label>
                <input 
                    cFormControl 
                    type="email" 
                    id="email" 
                    formControlName="email"
                    placeholder="usuario@ejemplo.com"
                    [class.is-valid]="isValid('email')"
                    [class.is-invalid]="isInvalid('email')"
                />
                @if (getErrorMessage('email')) {
                    <p class="text-danger">
                        {{ getErrorMessage('email') }}
                    </p>
                }
            </div>

            <div class="mb-3">
                <label cLabel for="password">Contraseña</label>
                <input 
                    cFormControl 
                    type="password" 
                    id="password" 
                    formControlName="password"
                    placeholder="••••••••"
                    [class.is-valid]="isValid('password')"
                    [class.is-invalid]="isInvalid('password')"
                />
                @if (getErrorMessage('password')) {
                    <p class="text-danger">
                        {{ getErrorMessage('password') }}
                    </p>
                }
            </div>

            <div class="d-grid">
                <button cButton color="primary" type="submit" [disabled]="form.invalid || isLoading()">
                    @if (isLoading()) {
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Ingresando...
                    } @else {
                        Ingresar
                    }
                </button>
            </div>
        </form>

    </ng-container>
    <ng-container auth-footer>
        <a routerLink="/recuperar-contrasena" class="text-white text-decoration-underline">
            <span>
                ¿Olvidaste tu contraseña?
            </span>
        </a>
    </ng-container>
</app-auth-base-layout>